import { render, staticRenderFns } from "./NotificationTab.vue?vue&type=template&id=3a9a9c44&scoped=true&"
import script from "./NotificationTab.vue?vue&type=script&lang=js&"
export * from "./NotificationTab.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTab.vue?vue&type=style&index=0&id=3a9a9c44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9a9c44",
  null
  
)

export default component.exports